import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { AuthRoutingModule } from "./auth-routing.module";
import { LoginComponent } from "./login/login.component";
import { SignupComponent } from "./signup/signup.component";
import { PasswordResetComponent } from "./password-reset/password-reset.component";
import { LogoutComponent } from "./logout/logout.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { RoleSignupComponent } from "./role-signup/role-signup.component";
import { SubscriptionComponent } from "./subscription/subscription.component";
import { PaymentSubscriptionComponent } from "./payment-subscription/payment-subscription.component";
import { PaymentSuccessComponent } from "./payment-success/payment-success.component";
import { PaymentFailureComponent } from "./payment-failure/payment-failure.component";
import { SubcriptionEndComponent } from "./subcription-end/subcription-end.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { TermConditionPageComponent } from "./term-condition-page/term-condition-page.component";
import { MaterialExampleModule } from "../material.module";
import { VerifyOtpForgotPasswordComponent } from "./verify-otp-forgot-password/verify-otp-forgot-password.component";
import { ChangeForgotPasswordComponent } from "./change-forgot-password/change-forgot-password.component";
import { NgOtpInputModule } from "ng-otp-input";
import { RoleSelectionComponent } from './role-selection/role-selection/role-selection.component';
import { LoginEmployeeComponent } from './login-employee/login-employee.component';

@NgModule({
  declarations: [
    LoginComponent,
    SignupComponent,
    PasswordResetComponent,
    LogoutComponent,
    SubscriptionComponent,
    PaymentSubscriptionComponent,
    ForgotPasswordComponent,
    RoleSignupComponent,
    PaymentSuccessComponent,
    PaymentFailureComponent,
    SubcriptionEndComponent,
    TermConditionPageComponent,
    VerifyOtpForgotPasswordComponent,
    ChangeForgotPasswordComponent,
    RoleSelectionComponent,
    LoginEmployeeComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,

    ReactiveFormsModule,
    HttpClientModule,
    NgxSpinnerModule,
    MaterialExampleModule,
    NgOtpInputModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AuthModule {}
